var Backbone = require('backbone'),
    Box = require('./box'),
    ShapeUtils = require('../../../../canvas/models/shapeUtils');


module.exports = Backbone.Model.extend({

    /**
     * boxPx:
     * - always derived from the DPI of the OCR engine from twips
     * - since images in DV are always printed in pixels, should always work; use for 'overlays'
     * - also if DPI incorrect for OCR ( it gives default of 300 if none exists ), it's coordinates should still map to the image,
     * - to get to pixels with whatever DPI it chooses
     * - also store on load in case we need to use to calc 'space' on the page
     * - can be used for positioning via CSS
     * boxFDDZoneUnits:
     * - use for anything canvas/zone related
     * - really the the the size of 1/10 mm using FDD's DPI ( in case different than that of the OCR engine )
     * - now really the units the box would be stored in, in zone files -- not just 1/10mm but assumes FDD's DPI
     * - this will resolve problems where the DPI of the OCR engine and FDD differ, which could occur, for instance,
     * - if there is no DPI stored with the image; here they each can make different assumptions.
     */
    defaults: {

        id: null, // overall id at the document level ( not the page level; index of the original and derived word arrays )

        page_level_key: null, // this could also be a unique identifier
        page_level_id: null, // unique index of this item type on the page ( line and zone )

        pageNumber: null,
        pageId: null,

        boxPx: null,
        boxFDDZoneUnits: null,
        boxPxDerived: null,
        boxFDDZoneUnitsDerived: null

    },

    parse: function( attrs, options ) {

        var taAttrs = {
            page_level_id: options.page_level_id,
            page_level_key:  this._generatePageKeyId( options ),
            pageNumber: options.pageNumber,
            pageId: options.pageId
        };

        /** For now continue to set non-derived boxes on parse */
        taAttrs.boxPx = this._generateBoxPx( attrs, options.ocr_xdpi );

        // Always use the dpi from FDD ( if it's the same as the OCR engine, it will be the same anyway )
        taAttrs.boxFDDZoneUnits = this._generateBoxFDDZoneUnits( taAttrs.boxPx, options.fdd_xdpi );

        return taAttrs;

    },

    _generatePageKeyId: function( options ) {
        return options.pageNumber + '_' + options.page_level_id;
    },


    // Always use OCR-DPI !
    _generateBoxPx: function( attrs, ocr_xdpi ) {

        return new Box({
            l: this.twipsToPx( attrs.l, ocr_xdpi, 1, 0 ),
            r: this.twipsToPx( attrs.r, ocr_xdpi, 0, 1 ),
            t: this.twipsToPx( attrs.t, ocr_xdpi, 1, 0 ),
            b: this.twipsToPx( attrs.b, ocr_xdpi, 0, 1 )
        } );

    },

    // Conversion performed with appropriate rounding to get more of the area
    // DPI is is the DPI of the FDD image ( if they are the same, it'd be the same value anyway )
    _generateBoxFDDZoneUnits: function( boxPx, fdd_xdpi ) {

        return new Box({
            l: Math.floor( ShapeUtils.pxToTenthsMM( boxPx.get('l'), fdd_xdpi ) ),
            r: Math.ceil( ShapeUtils.pxToTenthsMM( boxPx.get('r'), fdd_xdpi ) ),
            t: Math.floor( ShapeUtils.pxToTenthsMM( boxPx.get('t'), fdd_xdpi ) ),
            b: Math.ceil( ShapeUtils.pxToTenthsMM( boxPx.get('b'), fdd_xdpi ) )
        });

    },


    /**
     * Called post-parse ( in case needs other models needed for calculation )--
     * see word model.
     * Refactor warranted.
     */
    setDerivedBoxes: function( box_px_adjustment, fdd_xdpi ) {

        var boxPxDerived =
            this._generateBoxPxDerived( this.get('boxPx'), box_px_adjustment );

        var boxFDDZoneUnitsDerived =
            this._generateBoxFDDZoneUnitsDerived( boxPxDerived, fdd_xdpi );

        this.set({
            boxPxDerived: boxPxDerived,
            boxFDDZoneUnitsDerived: boxFDDZoneUnitsDerived
        });


    },

    /**
     * Adjust with BOX_PX_ADJUSTMENT ( sides )
     * This adjustment just adds to the pixels in the original -- no DPI taken into account
     * Can be overwritten for words
     * No rounding here ...
     */
    _generateBoxPxDerived: function( boxPx, box_px_adjustment  ) {

        return new Box({
            l: boxPx.get('l') - box_px_adjustment,
            r: boxPx.get('r') + box_px_adjustment,
            t: boxPx.get('t') - box_px_adjustment,
            b: boxPx.get('b') + box_px_adjustment
        } );

    },


    // Basically same as as proto._generateBoxFDDZoneUnits, without floor/ceil
    // Don't think need  floor/ ceil here -- it's already done on the initial pixel conversion
    _generateBoxFDDZoneUnitsDerived: function( boxPxDerived, fdd_xdpi ) {

        return new Box({
            l: ShapeUtils.pxToTenthsMM( boxPxDerived.get('l'), fdd_xdpi ) ,
            r: ShapeUtils.pxToTenthsMM( boxPxDerived.get('r'), fdd_xdpi ) ,
            t: ShapeUtils.pxToTenthsMM( boxPxDerived.get('t'), fdd_xdpi ) ,
            b: ShapeUtils.pxToTenthsMM( boxPxDerived.get('b'), fdd_xdpi )
        });

    },



    // TODO: what if different h and vdpi?
    // Note: control rounding so to the 'outside' to be more inclusive
    twipsToPx: function( twips, dpi, roundDown, roundUp ) {

        var unRoundedPixels = twips * dpi / 1440;

        if ( roundDown )
            return Math.floor( unRoundedPixels );

        if ( roundUp )
            return Math.ceil( unRoundedPixels );

        return Math.round( unRoundedPixels );

    },


    getBoxPx: function() {
        return this.get('boxPx');
    },

    getBoxPxDerived: function() {
        return this.get('boxPxDerived');
    },

    /**
     * Default return coordinates from boxPx
     * If useDerived, return coordinates from boxPxDerived ( use for testing calc's )
     */
    getBoxCssStyle: function( useDerived ) {

        var boxToUse = !useDerived
            ? this.getBoxPx()
            : this.getBoxPxDerived();

        return boxToUse.getBoxCssStyle( );
    }




});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/positionalTextModels/textAreaModels/textArea.js
 ** module id = 349
 ** module chunks = 0
 **/